export default __webpack_public_path__ + "media/2407da2026453f955f65f938fb7907e734e2f49ea620125e6c5e244fd360a463.svg";